import {graphql, useStaticQuery} from 'gatsby'

import type {DisallowedEmailsQuery} from '@/graphql-types'

// Checks the provided list of disallowed email patterns against the provided email address
export const checkEmailAgainst = (disallowedEmails: string[]) => (email: string) => {
    // We only test the disallowed patterns against the part of the email after the @
    const lastPartOfEmail = email.substring(email.indexOf('@') + 1)

    // This util is only concerned with checking against a list of disallowed
    // email patterns. We do basic email validation separately
    return !disallowedEmails.some((disallowedEmail) => lastPartOfEmail === disallowedEmail)
}

export const useIsCompanyEmail = (email: string) => {
    const {disallowedEmailsData} = useStaticQuery<DisallowedEmailsQuery>(query)

    return checkEmailAgainst(disallowedEmailsData?.emails ?? [])(email)
}

const query = graphql`
    query DisallowedEmails {
        disallowedEmailsData {
            emails
        }
    }
`
